import { render, staticRenderFns } from "./Layout.vue?vue&type=template&id=2c1857a6&scoped=true"
var script = {}
import style0 from "./Layout.vue?vue&type=style&index=0&id=2c1857a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1857a6",
  null
  
)

export default component.exports